import { eventsList } from '../../events/list';
import { CorrelationId } from '../../utils/CorrelationId';
import { initHttp } from '../../utils/http';
import { extendDeep } from '../../utils/utils';
import { addEvents } from '../decorators';
import { initItems } from './items';
import { initPreferences } from './preferences';
import { defaultSettings } from './settings';
import { initTopics } from './topics';
import { validateSettings } from './utils';
export function Recommended(userSettings) {
  if (userSettings === void 0) {
    userSettings = {};
  }
  this.siteMediaToken = userSettings.siteMediaToken;
  const settings = extendDeep(userSettings.metaSiteToken ? {
    requestOptions: {
      headers: {
        Authorization: userSettings.metaSiteToken
      }
    }
  } : {}, defaultSettings, userSettings);
  validateSettings(settings);
  const correlationId = new CorrelationId();
  const http = initHttp(settings.requestOptions);

  // TODO: implement favorite

  const items = initItems(settings, http);
  const preferences = initPreferences(settings, http);
  const topics = initTopics(settings, http);
  this.name = 'recommended';
  this.correlationId = correlationId;
  this.items = addEvents(this, eventsList.ITEMS, items);
  this.preferences = addEvents(this, eventsList.PREFERENCES, preferences);
  this.topics = addEvents(this, eventsList.TOPICS, topics);
}